export enum FormularioEnum {
	SGR_GuiaRemision = 'SGR-GUIA-ELECTRONICA',

	//MAESTROS
	SMA_TRANSPORTISTA = 'SMA-TRANSPORTISTA',
	SMA_SERIE = 'SMA-SERIE-GUIA-REMISION',
	SMA_ENTIDAD_LOCAL = 'SMA-ENTIDAD-LOCAL',
	SMA_VEHICULO = 'SMA-VEHICULO',
	SMA_CARRETA = 'SMA-CARRETA',
	SMA_CHOFER = 'SMA-CHOFER',
	SMA_CONCEPTO = 'SMA-CONCEPTO',
	SMA_PROVEEDOR = 'SMA-PROVEEDOR',
	SMA_DEPOSITO = 'SMA-DEPOSITO',
	SMA_INCIDENCIA = 'SMA-INCIDENCIA',
	SMA_ENTIDAD_CONTACTO = 'SMA-ENTIDAD-CONTACTO',
}
